<template>
  <g class="menuIcon" transform="translate(2.5,0) matrix(0.35 0 0 0.35 0 0)">
    <path
      d="M19.0001 12.6668L17.7334 11.4001C14.9351 8.60181 10.3982 8.60181 7.59997 11.4001V11.4001C4.8017 14.1983 4.8017 18.7352 7.59998 21.5335L8.86666 22.8002M19.0001 32.9336L19.5223 33.4559C20.2219 34.1554 21.3561 34.1554 22.0557 33.4559V33.4559C22.7552 32.7563 22.7552 31.6221 22.0557 30.9225L21.2168 30.0836L22.7446 31.6114C23.4441 32.311 24.5784 32.311 25.2779 31.6114V31.6114C25.9775 30.9118 25.9775 29.7776 25.2779 29.078L21.5335 25.3336L25.9668 29.7669C26.6664 30.4665 27.8006 30.4665 28.5002 29.7669V29.7669C29.1998 29.0674 29.1998 27.9331 28.5002 27.2336L24.0668 22.8002L27.8113 26.5447C28.5109 27.2442 29.6451 27.2442 30.3447 26.5447V26.5447C31.0442 25.8451 31.0442 24.7109 30.3447 24.0113L21.5335 15.2001"
      stroke="#F2F3F7"
      stroke-width="1.5"
      fill="none"
    />
    <rect
      x="12.0334"
      y="19.6335"
      width="3.58271"
      height="7.16542"
      rx="1.79136"
      transform="rotate(45 12.0334 19.6335)"
      stroke="#F2F3F7"
      stroke-width="1.5"
      fill="none"
    />
    <rect
      x="14.5668"
      y="22.1665"
      width="3.58271"
      height="8.0611"
      rx="1.79136"
      transform="rotate(45 14.5668 22.1665)"
      stroke="#F2F3F7"
      stroke-width="1.5"
      fill="none"
    />
    <rect
      x="17.1001"
      y="24.7002"
      width="3.58271"
      height="7.16542"
      rx="1.79136"
      transform="rotate(45 17.1001 24.7002)"
      stroke="#F2F3F7"
      stroke-width="1.5"
      fill="none"
    />
    <rect
      x="19.6334"
      y="27.2341"
      width="3.58271"
      height="6.26974"
      rx="1.79136"
      transform="rotate(45 19.6334 27.2341)"
      stroke="#F2F3F7"
      stroke-width="1.5"
      fill="none"
    />
    <path
      d="M28.8168 23.117L30.4002 21.5337C33.1985 18.7354 33.1985 14.1985 30.4002 11.4002V11.4002C27.6019 8.60194 23.065 8.60194 20.2667 11.4002L14.7778 16.8892C14.6612 17.0058 14.6612 17.1948 14.7778 17.3114L14.8482 17.3818C16.0918 18.6254 18.1082 18.6254 19.3519 17.3818L21.8501 14.8836"
      stroke="#F2F3F7"
      stroke-width="1.5"
      fill="none"
    />
  </g>
</template>
